module.exports = __webpack_public_path__ + "img/geofisica_4-3_1536.5dbd57f4.webp";